module.exports = __webpack_public_path__ + "img/debug-menu.d056a251.gif";